module.exports = __webpack_public_path__ + "img/3b.952e4e97.jpg";